function redirect(routeName, params = {}) {
    window.location.href = route(routeName, params);
}

export {redirect};
